<script setup lang="ts">
import { HousingApplication, HousingApplicationStatus } from "~/api";
import { useHousingAplicationWizard } from "~/YYC_Housing/composables/useHousingApplicationWizard";
import { ApplicationWizardStep } from "~/YYC_Housing/Intake/types/plusTypes";
import { ref } from "vue";
import { ElMessage } from "element-plus";

const props = defineProps<{
  housingApplication: HousingApplication;
}>();

const emit = defineEmits<{
  (e: "open:applicationForm"): void;
  (e: "open:finder"): void;
  (e: "submitted"): void;
}>();
const isConfirmedReadyForPRS = ref<boolean>(false);

const { stepStatusMap, handleSubmitApplication } = useHousingAplicationWizard(
  props.housingApplication,
);

const handleSubmitApplicationWrapper = async () => {
  await handleSubmitApplication();
  ElMessage({ type: "success", message: "Moved to New & Review" });
  emit("submitted");
};
</script>
<template>
  <div class="info-msg">
    <span
      >Complete the following to move this application to New & Review:</span
    >
    <ul class="checklist">
      <el-checkbox
        disabled
        :model-value="
          stepStatusMap[ApplicationWizardStep.SelectLocations].completed
        "
        @click="emit('open:finder')"
        >Select Locations

        <el-button size="small" @click="emit('open:finder')">
          <span
            v-if="
              !stepStatusMap[ApplicationWizardStep.SelectLocations].completed
            "
          >
            Start
          </span>
          <span v-else>Change</span>
        </el-button>
      </el-checkbox>
      <el-checkbox
        disabled
        :model-value="
          stepStatusMap[ApplicationWizardStep.ApplicationForm].completed
        "
        @click="emit('open:applicationForm')"
        >Application Form
        <el-button size="small" @click="emit('open:applicationForm')">
          <span
            v-if="
              !stepStatusMap[ApplicationWizardStep.ApplicationForm].completed
            "
          >
            Start
          </span>
          <span v-else>Edit</span>
        </el-button>
      </el-checkbox>
    </ul>
  </div>

  <div style="display: flex; flex-direction: column">
    <el-checkbox
      v-model="isConfirmedReadyForPRS"
      :disabled="
        !stepStatusMap[ApplicationWizardStep.SelectLocations].completed ||
        !stepStatusMap[ApplicationWizardStep.ApplicationForm].completed
      "
    >
      I confirm that all the information above has been reviewed and this
      application is ready for PRS.
    </el-checkbox>
    <el-button
      style="width: min-content"
      :disabled="
        !stepStatusMap[ApplicationWizardStep.SelectLocations].completed ||
        !stepStatusMap[ApplicationWizardStep.ApplicationForm].completed ||
        !isConfirmedReadyForPRS ||
        housingApplication?.status !== HousingApplicationStatus.DRAFT
      "
      @click="handleSubmitApplicationWrapper"
      >Move to New & Review</el-button
    >
  </div>
</template>
<style lang="less"></style>
